
import React, { useState } from 'react';
import { FiPlus, FiMinus } from 'react-icons/fi'; // Iconos de react-icons
import '../../css/TerminosDelSorteo.css'
import {CONSTANTES} from "../../config/constantaes";

const TerminosDelSorteo = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => setIsOpen(!isOpen);

  
 return (
    <div className='content-modal'>
      <div onClick={toggleAccordion} className='content-modal-titulo'>
        <strong className='titulo-term'>Términos del sorteo</strong>
        {isOpen ? <FiMinus color="#f44336" /> : <FiPlus color="#f44336" />}
      </div>

      <div className='context-modal'>
        {isOpen && (
            <p>
                <p>
                   TCEA máxima referencial 125.70%, calculada considerando una TEA de 110.00%, aplicable para un monto 
                   de S/ 5000.00 a un plazo de 12 meses con una cuota mensual referencial de S/ 634.50, que incluye el 
                   seguro de desgravamen mensual tradicional básico de 0.65%, conforme al tarifario vigente. Carácter 
                   opcional: En caso el cliente opte por la contratación del crédito sin un Seguro de desgravamen, realizar 
                   la contratación de un seguro de desgravamen con retorno / devolución , o endosar un seguro de vida, 
                   la TCEA variará. Más información de tasas, comisiones, gastos y demás condiciones en alfincontacto.com.pe 
                   en las oficinas de atención o llamando a nuestra Banca Telefónica (01) 613-0004. Términos y condiciones 
                   de “Alfin te premia”. Vigencia: Del 15/01/2026 al  15/05/2026. Requisitos: (I) Para participar del sorteo 
                   debe registrarse de manera correcta en <a href="https://alfincontacto.com.pe" target="_blank" rel="noopener noreferrer">www.alfincontacto.com.pe</a> y aceptar el Consentimiento para el Tratamiento de Datos Personales y el Consentimiento para el Tratamiento de Datos Personales con 
                   Finalidades Comerciales. (II) El consentimiento brindado por el participante deberán mantenerse vigente durante 
                   toda la vigencia de la campaña, y hasta la fecha de entrega del premio, en caso resulte ganador (III) Los clientes 
                   de Alfin Banco que participen no deberán registrar cuotas vencidas, castigadas, refinanciadas, reprogramadas o en 
                   proceso judicial con Alfin Banco S.A. a la fecha de cada sorteo, y entrega del premio, de corresponder. Mecanismo de 
                   participación: (1) Al registrarse de manera correcta en <a href="https://alfincontacto.com.pe/home/clientes" target="_blank" rel="noopener noreferrer">www.alfincontacto.com.pe/home/clientes</a> y aceptar el Consentimiento para el Tratamiento de Datos Personales y el Consentimiento para el Tratamiento de Datos 
                   Personales con Finalidades Comerciales, se obtiene 1 opción de participación (2) Al cumplir con el mecanismo de 
                   participación Nro. (1) y adicionalmente realizar la contratación de un préstamo en Alfin Banco, tanto en agencia 
                   como a través de canal telefónico, se obtiene 5 opciones de participación. (3) Al cumplir con el mecanismo de 
                   participación Nro. (1) y adicionalmente remitan a Alfin Banco sus sustentos de ingresos asimismo firmen en nuestras 
                   agencias la “Constancia de Autorización de Tratamiento de Datos Personales Solvencia Patrimonial”, se obtiene 10 
                   opciones de participación. Fechas sorteos: Se realizarán 4 sorteos en total: los días 16/02/2026, el 16/03/2026, 
                   el 16/04/2026 y el 18/05/2026. Premios: En cada sorteo se escogerán a 3 ganadores, resultando 12 ganadores en total; 
                   quienes recibirán lo siguiente en cada sorteo: 1er. Ganador: (1) vale de S/ 1,000.00 para consumo en tiendas Carsa. 
                   2do. Ganador: (1) vale de S/ 500.00 para consumo en tiendas Tai Loy. 3er. Ganador: (1) vale de S/ 500.00 para consumo 
                   en tiendas Tai Loy. Más información de los términos y condiciones del sorteo en <a href="https://www.alfinbanco.pe/comunicados" target="_blank" rel="noopener noreferrer">www.alfinbanco.pe/comunicados </a>
                </p>

            </p>
        )}
      </div>
    </div>
 );
};

export default TerminosDelSorteo;